import { render } from "./PolygonsConfig.vue?vue&type=template&id=b5dc545a&scoped=true"
import script from "./PolygonsConfig.vue?vue&type=script&lang=js"
export * from "./PolygonsConfig.vue?vue&type=script&lang=js"

import "./PolygonsConfig.vue?vue&type=style&index=0&id=b5dc545a&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5dc545a"]])

export default __exports__